// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 283 ? "fe680085" : chunkId) + "." + {"283":"7dbd3f3d8dccb8ca","844":"c30251d1ccbc7a74"}[chunkId] + ".js";
};